import { PAY_BREAKDOWN_PATH } from "@/payroll/pay-breakdown/routes";
import { PROFITABILITY_PATH } from "@/profitability/routes";

interface DefaultRouteAccess {
  hasPayBreakdownAccess: boolean;
  enableReferrals: boolean;
  enableAp: boolean;
  canOpenProfitability: boolean;
}

/**
 * Where `/` sends a signed-in user past onboarding: their first product, in
 * this order, or their profile. `ProtectedRoute` redirects there, and the
 * sidebar's home link points straight at it, so following it doesn't render
 * `/` on the way.
 */
export const getDefaultRoute = ({
  hasPayBreakdownAccess,
  enableReferrals,
  enableAp,
  canOpenProfitability,
}: DefaultRouteAccess) => {
  if (hasPayBreakdownAccess) return PAY_BREAKDOWN_PATH;
  if (enableReferrals) return "/referrals";
  if (enableAp) return "/accounts-payable";
  if (canOpenProfitability) return PROFITABILITY_PATH;
  return "/profile";
};

// Impersonation starts at an enabled product, rather than retaining the previous
// user's page. Keep the normal sign-in landing order separate.
export const getImpersonationRoute = ({
  hasPayBreakdownAccess,
  enableReferrals,
  enableAp,
  canOpenProfitability,
  enablePayroll,
}: DefaultRouteAccess & { enablePayroll: boolean }) => {
  if (canOpenProfitability) return PROFITABILITY_PATH;
  if (enableAp) return "/accounts-payable";
  if (enablePayroll && hasPayBreakdownAccess) return PAY_BREAKDOWN_PATH;
  if (enableReferrals) return "/referrals";
  return "/profile";
};
